export const languages = ["zh-CN", "en-US"];

const locales = {};
locales[languages[0]] = {
  PAGEBUIDER_ELEMENT_SORT_FORM: "表单",
  PAGEBUIDER_ELEMENT_FORM_INPUT: "文本输入",
  PAGEBUIDER_ELEMENT_FORM_INPUTNUMBER: "数字输入",
  PAGEBUIDER_ELEMENT_FORM_TEXTAREA: "文本域",
  PAGEBUIDER_ELEMENT_FORM_PASSWORD: "密码框",
  PAGEBUIDER_ELEMENT_FORM_SELECT: "下拉框",
  PAGEBUIDER_ELEMENT_FORM_CASCADER: "级联",
  PAGEBUIDER_ELEMENT_FORM_RADIOGROUP: "单选框",
  PAGEBUIDER_ELEMENT_FORM_CHECKBOXGROUP: "复选框",
  PAGEBUIDER_ELEMENT_FORM_DATEPICKER: "日期控件",
  PAGEBUIDER_ELEMENT_FORM_RANGEPICKER: "日期范围",
  PAGEBUIDER_ELEMENT_FORM_TIMEPICKER: "时间控件",
  PAGEBUIDER_ELEMENT_FORM_SWITCH: "开关",
  PAGEBUIDER_ELEMENT_FORM_SLIDER: "滑动选择",
  PAGEBUIDER_ELEMENT_FORM_RATE: "评分",
  PAGEBUIDER_ELEMENT_FORM_UPLOAD: "上传",
  PAGEBUIDER_ELEMENT_FORM_POPEDIT: "弹出选择",
  PAGEBUIDER_ELEMENT_FORM_PARTICIPANT: "参与人",
  PAGEBUIDER_ELEMENT_TABLE_PARTICIPANT_ID: "参与人ID",
  PAGEBUIDER_ELEMENT_TABLE_PARTICIPANT_NAME: "参与人名称",
  PAGEBUIDER_ELEMENT_TABLE_PARTICIPANT_TYPE: "参与人类型",
  PARTICIPANT_SETTINGS_PAGE_URL: "参与人选择页面链接",
  PAGEBUIDER_ELEMENT_FORM_IMAGEUPLOAD: "图片上传",
  PAGEBUIDER_ELEMENT_FORM_TREE: "树控件",
  PAGEBUIDER_ELEMENT_FORM_TREESELECT: "下拉树",
  PAGEBUIDER_SETTINGS_PROPERTY_REMOTE_COMPONENT: "远程组件",
  PAGEBUIDER_SETTINGS_REMOTE_URL: "url",
  REMOTE_COMPONENT_PARAMTERS: "远程组件参数",
  PAGEBUIDER_ELEMENT_FORM_RICHEDITOR: "富文本",
  PAGEBUIDER_ELEMENT_FORM_BUTTON: "标准按钮",
  PAGEBUIDER_ELEMENT_FORM_TABLE: "表格",
  PAGEBUIDER_ELEMENT_FORM_HEADERCELL: "表格头",
  PAGEBUIDER_ELEMENT_FORM_TABLEEDIT: "可编辑表格",
  PAGEBUIDER_EDITOR_TABLE_HEADER_CELL: "新增列",
  PAGEBUIDER_MSG_SETTINGS_SUCCESS: "设置属性成功",
  PAGEBUIDER_MSG_OPTIONS_REMOTE_SUCCESS: "设置远程型选项成功",
  PAGEBUIDER_MSG_OPTIONS_REMOTE_FAIL: "设置远程型选项失败. 请检查数据源",
  PAGEBUIDER_MSG_OPTIONS_REMOTE_WARN: "已设置为远程型选项！但数据还未初始化",
  PAGEBUIDER_MSG_OPTIONS_STATIC_SUCCESS: "设置静态型选项成功",
  PAGEBUIDER_MSG_SETTINGS_FAIL: "设置属性失败. 请检查数据源.",
  PAGEBUIDER_MSG_UPLOAD_FAIL: "上传文件失败，文件类型不配置.",
  PAGEBUIDER_MSG_DATA_SUCCESS: "设置数据源成功.",
  PAGEBUIDER_MSG_DATA_FAIL: "设置数据源失败，请检查你的URL.",
  PAGEBUIDER_TITLE_STATIC: "编辑静态数据",
  PAGEBUIDER_TITLE_REMOTE: "编辑远程数据",
  PAGEBUIDER_ELEMENT_TEXT_SUBMIT: "提交",
  PAGEBUIDER_PLS_SELECT: "请选择",
  PAGEBUIDER_PLS_SELECT_ICON: "请选择图标",
  PAGEBUIDER_ICON_TYPE_NORMAL: "常用图标",
  PAGEBUIDER_ICON_TYPE_OUTLINED: "线框风格",
  PAGEBUIDER_ICON_TYPE_FILLED: "实体风格",
  PAGEBUIDER_ICON_TYPE_TWO_TONE: "双色风格",
  PAGEBUIDER_ICON_SORT_DIRECTION_ICON: "方向性图标",
  PAGEBUIDER_ICON_SORT_TIPS_ICON: "提示性图标",
  PAGEBUIDER_ICON_SORT_EDIT_ICON: "编辑类图标",
  PAGEBUIDER_ICON_SORT_NORMAL_ICON: "网站常用图标",
  PAGEBUIDER_LANGUAGE_ZH: "中文",
  PAGEBUIDER_LANGUAGE_EN: "英文",
  PAGEBUIDER_ELEMENT_GROUP_CONTAINER: "容器组件",
  PAGEBUIDER_ELEMENT_GROUP_LAYOUT: "布局组件",
  PAGEBUIDER_ELEMENT_GROUP_FORM_INPUT: "输入组件",
  PAGEBUIDER_ELEMENT_GROUP_FORM_SELECT: "选择组件",
  PAGEBUIDER_ELEMENT_GROUP_FORM_COMPLEX: "复杂组件",
  PAGEBUIDER_ELEMENT_GROUP_FORM_CUSTOM: "定制组件",
  PAGEBUIDER_OPERATE_DELETE_TIPS: "提示",
  PAGEBUIDER_OPERATE_DELETE_TIPS_CONTENT: "确定要删除所有组件吗？",
  PAGEBUIDER_SETTINGS_INPUT_TABS_INPUT: "文本输入设置",
  PAGEBUIDER_SETTINGS_INPUT_TABS_MACRO: "宏数据设置",
  PAGEBUIDER_SETTINGS_INPUT_TABS_LABEL: "标签设置",
  PAGEBUIDER_SETTINGS_INPUT_TABS_INPUTNUMBER: "数字输入设置",
  PAGEBUIDER_SETTINGS_NAME: "字段名",
  PAGEBUIDER_SETTINGS_ALLOW_CLEAR: "能否清空",
  PAGEBUIDER_SETTINGS_DEFAULT_VALUE: "默认值",
  PAGEBUIDER_SETTINGS_PLACE_HOLDER: "占位提示",
  PAGEBUIDER_SETTINGS_VISIBLE: "是否可见",
  PAGEBUIDER_SETTINGS_VISIBLE_DOM: "是否占位",
  PAGEBUIDER_SETTINGS_DISABLED: "是否禁用",
  PAGEBUIDER_SETTINGS_REQUIRED: "校验",
  PAGEBUIDER_SETTINGS_REQUIRED_ITEM: "必填",
  PAGEBUIDER_SETTINGS_TYPE: "组件类型",
  PAGEBUIDER_SETTINGS_ADDON_BEFORE: "前缀",
  PAGEBUIDER_SETTINGS_ADDON_AFTER: "后缀",
  PAGEBUIDER_SETTINGS_MAX_LENGTH: "最多输入",
  PAGEBUIDER_SETTINGS_MESSAGE: "备注",
  PAGEBUIDER_SETTINGS_TEXT: "文本",
  PAGEBUIDER_SETTINGS_URL: "地址",
  PAGEBUIDER_SETTINGS_PASSWORD: "密码",
  PAGEBUIDER_SETTINGS_TEL: "电话",
  PAGEBUIDER_SETTINGS_EMAIL: "邮箱",
  PAGEBUIDER_SETTINGS_PLACEHOLDER_DEFAULT_VALUE: "输入默认值",
  PAGEBUIDER_SETTINGS_PLACEHOLDER_PLACEHOLDER: "输入占位提示",
  PAGEBUIDER_SETTINGS_MACRO: "宏数据",
  PAGEBUIDER_SETTINGS_LABEL_SETTING: "标签设置",
  PAGEBUIDER_SETTINGS_LABEL_TEXT: "标签文本",
  PAGEBUIDER_SETTINGS_LABEL_ALIGN: "标签对齐",
  PAGEBUIDER_SETTINGS_COLOR: "颜色",
  PAGEBUIDER_SETTINGS_LABEL_OFFSET: "标签偏移",
  PAGEBUIDER_SETTINGS_LEFT: "左",
  PAGEBUIDER_SETTINGS_CENTER: "中",
  PAGEBUIDER_SETTINGS_RIGHT: "右",
  PAGEBUIDER_SETTINGS_LABEL: "标签",
  PAGEBUIDER_SETTINGS_OFFSET: "偏移",
  PAGEBUIDER_SETTINGS_CASCADE_SETTING: "级联设置",
  PAGEBUIDER_SETTINGS_DATASOURCE_RELATION: "数据源关联",
  PAGEBUIDER_SETTINGS_VISIBLE_RELATION: "可见关联",
  PAGEBUIDER_SETTINGS_DISABLE_RELATION: "禁用关联",
  PAGEBUIDER_SETTINGS_REQUIRE_RELATION: "必填关联",
  PAGEBUIDER_SETTINGS_RELATION: "关联",
  PAGEBUIDER_SETTINGS_INPUT: "输入",
  PAGEBUIDER_SETTINGS_OUTPUT: "输出",
  PAGEBUIDER_SETTINGS_DEFAULT_OUTPUT: "默认输出",
  PAGEBUIDER_SETTINGS_PLEASE_INPUT_VALUE: "请输入",
  PAGEBUIDER_SETTINGS_RELATION_ITEM: "关联项",
  PAGEBUIDER_SETTINGS_VALUE: "值",
  PAGEBUIDER_SETTINGS_EVENT_SETTING: "事件",
  PAGEBUIDER_SETTINGS_PLS_INPUT: "请输入",
  PAGEBUIDER_SETTINGS_EVENT: "事件类型",
  PAGEBUIDER_SETTINGS_FUNCTION: "事件名称",
  PAGEBUIDER_SETTINGS_OPERATION: "操作",
  PAGEBUIDER_SETTINGS_CONFIRM_DELETE: "确定删除吗?",
  PAGEBUIDER_SETTINGS_CONFIRM_CANCEL: "确定取消吗?",
  PAGEBUIDER_SETTINGS_ADD_NEW_EVENT: "新增一个事件",
  PAGEBUIDER_SETTINGS_COLUMN_GRID: "栅格列",
  PAGEBUIDER_SETTINGS_INPUTNUMBER: "数字输入",
  PAGEBUIDER_SETTINGS_MAX: "最大值",
  PAGEBUIDER_SETTINGS_MIN: "最小值",
  PAGEBUIDER_SETTINGS_PRECISION: "精度",
  PAGEBUIDER_SETTINGS_STEP: "步长",
  PAGEBUIDER_SETTINGS_WIDTH: "宽度",
  PAGEBUIDER_SETTINGS_FORM_TABS_TEXTAREA: "文本域设置",
  PAGEBUIDER_SETTINGS_AUTOSIZE: "自动调整大小",
  PAGEBUIDER_SETTINGS_MAX_ROWS: "最大行数",
  PAGEBUIDER_SETTINGS_TEXT_AREA: "文本域",
  PAGEBUIDER_SETTINGS_FORM_TABS_PASSWORD: "密码设置",
  PAGEBUIDER_SETTINGS_VISIBILITY_TOGGLE: "切换按钮",
  PAGEBUIDER_SETTINGS_READONLY: "只读",
  PAGEBUIDER_SETTINGS_HEIGHT: "高度",
  PAGEBUIDER_SETTINGS_FULL_HEIGHT: "全高",
  PAGEBUIDER_SETTINGS_MARGIN: "边距",
  PAGEBUIDER_SETTINGS_LAYOUT: "布局",
  PAGEBUIDER_SETTINGS_DESKTOP: "桌面端",
  PAGEBUIDER_SETTINGS_MOBILE: "移动端",
  PAGEBUIDER_SETTINGS_SHOW_ADVANCED: "显示高级设置",
  PAGEBUIDER_SETTINGS_PADDING: "填充",
  PAGEBUIDER_SETTINGS_FORM_TABS_BUTTON: "按钮设置",
  PAGEBUIDER_SETTINGS_FORM_TABS_COLUMN: "列设置",
  PAGEBUIDER_SETTINGS_BUTTON_ALIGN: "按钮对齐",
  PAGEBUIDER_SETTINGS_FORM: "表单对齐",
  PAGEBUIDER_SETTINGS_GHOST: "幽灵",
  PAGEBUIDER_SETTINGS_HTML_TYPE: "页面类型",
  PAGEBUIDER_SETTINGS_ICON: "图标",
  PAGEBUIDER_SETTINGS_BTN_TYPE_HTML_SUBMIT: "提交",
  PAGEBUIDER_SETTINGS_BTN_TYPE_HTML_RESET: "重置",
  PAGEBUIDER_SETTINGS_BTN_TYPE_HTML_BUTTON: "按钮",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_PRIMARY: "主色调",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_DASHED: "虚线框",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_DANGER: "危险型",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_LINK: "链接型",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_DEFAULT: "默认型",
  PAGEBUIDER_SETTINGS_FORM_TABS_SELECT: "下拉设置",
  PAGEBUIDER_SETTINGS_FORM_TABS_OPTIONS: "数据源设置",
  PAGEBUIDER_SETTINGS_SHOW_SEARCH: "能否搜索",
  PAGEBUIDER_SETTINGS_FILTER_PROP: "搜索对象",
  PAGEBUIDER_SETTINGS_SHOW_ARROW: "显示箭头",
  PAGEBUIDER_SETTINGS_LISTHEIGHT: "列表最高高度",
  PAGEBUIDER_SETTINGS_MODE: "类型",
  PAGEBUIDER_SETTINGS_MAX_TAG_COUNT: "最大标签数",
  PAGEBUIDER_SETTINGS_MODE_SINGLE: "单选",
  PAGEBUIDER_SETTINGS_MODE_MULTIPLE: "多选",
  PAGEBUIDER_SETTINGS_MODE_TAGS: "标签",
  PAGEBUIDER_SETTINGS_DATASOURCE: "数据源",
  PAGEBUIDER_SETTINGS_DATASOURCE_STATIC: "静态型",
  PAGEBUIDER_SETTINGS_DATASOURCE_REMOTE: "远程型",
  PAGEBUIDER_SETTINGS_ADD_NEW_OPTION: "新增一个属性",
  PAGEBUIDER_SETTINGS_FORM_TABS_CASCADER: "级联设置",
  "PAGEBUIDER_SETTINGS_FORM-TABS_SELECT_OPTIONS": "数据源属性",
  PAGEBUIDER_SETTINGS_CHANGE_ON_SELECT: "选择时值变化",
  PAGEBUIDER_SETTINGS_EXPAND_TRIGGER: "展开时触发",
  PAGEBUIDER_SETTINGS_POPUP_PLACEMENT: "弹框位置",
  PAGEBUIDER_SETTINGS_TRIGGER_CLICK: "点击",
  PAGEBUIDER_SETTINGS_TRIGGER_HOVER: "鼠标移入",
  PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOMLEFT: "下方左边",
  PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOMRIGHT: "下方右边",
  PAGEBUIDER_SETTINGS_PLACEMENT_TOPLEFT: "上方左边",
  PAGEBUIDER_SETTINGS_PLACEMENT_TOPRIGHT: "上方右边",
  PAGEBUIDER_SETTINGS_FORM_TABS_RADIO: "单选设置",
  PAGEBUIDER_SETTINGS_FORM_TABS_CHECKBOX: "复选设置",
  PAGEBUIDER_SETTINGS_FORM_TABS_SWITCH: "开关设置",
  PAGEBUIDER_SETTINGS_SWITCH_DEFAULT_CHECKED: "默认值",
  PAGEBUIDER_SETTINGS_SWITCH_CHECKED_CHILD: "选中时内容",
  PAGEBUIDER_SETTINGS_SWITCH_UNCHECKED_CHILD: "非选中时内容",
  PAGEBUIDER_SETTINGS_FORM_TABS_RATE: "评分设置",
  PAGEBUIDER_SETTINGS_ALLOW_HALF: "能否半选",
  PAGEBUIDER_SETTINGS_COUNT: "计数",
  PAGEBUIDER_SETTINGS_FORM_TABS_SLIDER: "滑动设置",
  PAGEBUIDER_SETTINGS_DOTS: "显示间断点",
  PAGEBUIDER_SETTINGS_RANGE: "范围选择",
  PAGEBUIDER_SETTINGS_REVERSE: "方向",
  PAGEBUIDER_SETTINGS_TOOLTIP: "提示",
  PAGEBUIDER_SETTINGS_PLACEMENT: "位置",
  PAGEBUIDER_SETTINGS_PLACEMENT_TOP: "上方",
  PAGEBUIDER_SETTINGS_PLACEMENT_RIGHT: "右边",
  PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOM: "下方",
  PAGEBUIDER_SETTINGS_PLACEMENT_LEFT: "左边",
  PAGEBUIDER_SETTINGS_PLACEMENT_LEFTTOP: "左上方",
  PAGEBUIDER_SETTINGS_PLACEMENT_LEFTBOTTOM: "左下方",
  PAGEBUIDER_SETTINGS_PLACEMENT_RIGHTTOP: "左上方",
  PAGEBUIDER_SETTINGS_PLACEMENT_RIGHTBOTTOM: "右下方",
  PAGEBUIDER_SETTINGS_UNSET: "无",
  PAGEBUIDER_SETTINGS_CHINESE: "中文",
  PAGEBUIDER_SETTINGS_ADD_ITEM: "增加一项",
  PAGEBUIDER_SETTINGS_REQUIRED_TIPS: "这是必填项。",
  PAGEBUIDER_SETTINGS_REQUIRED_TABLE_TIPS: "表格数据源不可为空。",
  PAGEBUIDER_SETTINGS_TIPS_ACCEPT_TYPE: "请输入可以接受的类型。",
  PAGEBUIDER_SETTINGS_TIPS_REQUIRE_SELECT: "请选择校验规则",
  PAGEBUIDER_SETTINGS_TIPS_REQUIRE_INPUT: "请输入正则表达式",
  PAGEBUIDER_SETTINGS_PLATFORM_RELATED_DEVELOPMENT: "平台相关开发",
  PAGEBUIDER_SETTINGS_FORM_TABS_BASIC: "基本设置",
  PAGEBUIDER_SETTINGS_FORM_TABS_DATA: "数据源设置",
  PAGEBUIDER_SETTINGS_DEFAULT_VALUE_SET: "默认值设置",
  PAGEBUIDER_SETTINGS_DATATEXTFIELD: "显示值字段",
  PAGEBUIDER_SETTINGS_DATAVALUEFIELD: "实际值字段",
  PAGEBUIDER_SETTINGS_PAGE_URL: "Url",
  PAGEBUIDER_SETTINGS_TITLE: "标题",
  PAGEBUIDER_SETTINGS_MODAL_WIDTH: "弹框宽度",
  PAGEBUIDER_SETTINGS_MODAL_HEIGHT: "弹框高度",
  PAGEBUIDER_SETTINGS_ADD_NEW_ITEM: "增加一项",
  PAGEBUIDER_SETTINGS_PLEASE_INPUT_NAME: "请输入字段名",
  PAGEBUIDER_SETTINGS_AUTO_INITILIZE: "自动初始化数据",
  PAGEBUIDER_SETTINGS_EXPANDALL: "展开所有",
  PAGEBUIDER_SETTINGS_MULTIPLE: "能否多选",
  PAGEBUIDER_SETTINGS_HIDE_LABEL: "隐藏标签",
  PAGEBUIDER_SETTINGS_SHOWERROR: "展示错误文件",
  PAGEBUIDER_SETTINGS_TABLE_KEY: "表格主键",
  PAGEBUIDER_SETTINGS_SIZE: "大小",
  PAGEBUIDER_SETTINGS_SCROLLX: "横向滚动",
  PAGEBUIDER_SETTINGS_SCROLLY: "纵向滚动",
  PAGEBUIDER_SETTINGS_BORDERED: "边框",
  PAGEBUIDER_SETTINGS_EXPANDICONPOSITION: "图标位置",
  PAGEBUIDER_SETTINGS_TABLE_LAYOUT: "表格布局",
  PAGEBUIDER_SETTINGS_ROW_SELECT: "行选择",
  PAGEBUIDER_SETTINGS_PAGINATION: "分页",
  PAGEBUIDER_SETTINGS_PAGE_SIZE: "每页条数",
  PAGEBUIDER_SETTINGS_SIZE_CHANGER: "每页条数切换器",
  PAGEBUIDER_SETTINGS_PAGE_TOTAL: "数据总数",
  PAGEBUIDER_SETTINGS_CHECKBOX: "复选",
  PAGEBUIDER_SETTINGS_RADIO: "单选",
  PAGEBUIDER_SETTINGS_FIXED: "固定",
  PAGEBUIDER_SETTINGS_DEFAULT: "默认",
  PAGEBUIDER_SETTINGS_MIDDLE: "中等",
  PAGEBUIDER_SETTINGS_SMALL: "小号",
  PAGEBUIDER_SETTINGS_COLUMNS: "列",
  PAGEBUIDER_SETTINGS_EDIT_COLUMNS_DATA: "编辑列数据",
  PAGEBUIDER_SETTINGS_EDIT_DATASOURCE: "编辑数据源",
  PAGEBUIDER_SETTINGS_FORM_TABS_UPLOAD: "上传设置",
  PAGEBUIDER_SETTINGS_ACCEPT: "接收类型",
  PAGEBUIDER_SETTINGS_UPLOAD_URL: "上传Url",
  PAGEBUIDER_SETTINGS_QUERY_URL: "查询Url",
  PAGEBUIDER_SETTINGS_DOWNLOAD_URL: "下载Url",
  PAGEBUIDER_SETTINGS_PREVIEW_URL: "预览Url",
  PAGEBUIDER_SETTINGS_WITH_CREDENTIALS: "是否携带cookie",
  PAGEBUIDER_SETTINGS_DIRECTORY: "目录",
  PAGEBUIDER_SETTINGS_PLS_SELECT_FILE_TYPE: "请选择文件类型",
  PAGEBUIDER_SETTINGS_PLS_INPUT_ACCEPT_TYPE: "请输入可接收的类型",
  PAGEBUIDER_SETTINGS_CLICK_TO_UPLOAD: "点击上传",
  PAGEBUIDER_SETTINGS_FORM_TABS_URL: "Url设置",
  PAGEBUIDER_SETTINGS_UPLOAD_NAME: "上传字段",
  PAGEBUIDER_SETTINGS_UPLOAD_FILESIZE: "文件大小",
  PAGEBUIDER_SETTINGS_PREVIEW_WIDTH: "预览宽度",
  PAGEBUIDER_SETTINGS_PREVIEW_HEIGHT: "预览高度",
  PAGEBUIDER_SETTINGS_BUTTON_TEXT: "按钮文字",
  PAGEBUIDER_SETTINGS_UPLOAD_SUCCESS: "成功提示",
  PAGEBUIDER_SETTINGS_UPLOAD_ERROR: "错误提示",
  PAGEBUIDER_SETTINGS_UPLOAD_FAILD: "失败提示",
  PAGEBUIDER_SETTINGS_UPLOAD_SUCCESS_DEFAULT: "文件上传成功",
  PAGEBUIDER_SETTINGS_UPLOAD_ERROR_DEFAULT: "文件类型错误",
  PAGEBUIDER_SETTINGS_UPLOAD_FAILD_DEFAULT: "文件上传失败",
  PAGEBUIDER_SETTINGS_UPLOAD_ERROR_SIZE: "文件大小超过限制:",
  PAGEBUIDER_SETTINGS_UPLOAD_ID_NAME: "文件id字段名",
  PAGEBUIDER_SETTINGS_VERTICAL_ALIGN: "垂直对齐",
  PAGEBUIDER_SETTINGS_HORIZONTAL_ALIGN: "水平对齐",
  PAGEBUIDER_SETTINGS_SHADOW: "阴影",
  PAGEBUIDER_SETTINGS_HORIZONTAL_OFFSET: "水平偏移",
  PAGEBUIDER_SETTINGS_VERTICAL_OFFSET: "垂直偏移",
  PAGEBUIDER_SETTINGS_BLUR: "移除焦点",
  PAGEBUIDER_SETTINGS_SPREAD: "展开",
  PAGEBUIDER_SETTINGS_RADIUS: "圆角",
  PAGEBUIDER_SETTINGS_STYLE: "样式",
  PAGEBUIDER_SETTINGS_BORDERS: "边框",
  PAGEBUIDER_SETTINGS_BORDER: "边框",
  PAGEBUIDER_SETTINGS_STYLE_NONE: "无",
  PAGEBUIDER_SETTINGS_STYLE_SOLID: "实线",
  PAGEBUIDER_SETTINGS_STYLE_DASHED: "虚线",
  PAGEBUIDER_SETTINGS_STYLE_DOTTED: "点线",
  PAGEBUIDER_SETTINGS_ANIMATION: "动画",
  PAGEBUIDER_SETTINGS_BACKGROUND: "背景",
  PAGEBUIDER_SETTINGS_IMAGE: "图片",
  PAGEBUIDER_SETTINGS_SELECT_AN_IAMGE: "选择一个图片",
  PAGEBUIDER_SETTINGS_SCALING: "缩放",
  PAGEBUIDER_SETTINGS_POSITION: "位置",
  PAGEBUIDER_SETTINGS_COVER: "覆盖背景区域",
  PAGEBUIDER_SETTINGS_CONTAIN: "充满内容区域",
  PAGEBUIDER_SETTINGS_ORIGIN_SIZE: "中心位置大小",
  PAGEBUIDER_SETTINGS_TITLE_HORIZONTAL: "水平标题",
  PAGEBUIDER_SETTINGS_TITLE_VERTICAL: "垂直标题",
  PAGEBUIDER_SETTINGS_FORM_SETTING: "表单设置",
  PAGEBUIDER_SETTINGS_FORM_SETTINGS: "表单设置",
  PAGEBUIDER_SETTINGS_FORM_SIZE: "表单大小",
  PAGEBUIDER_SETTINGS_FORM_LAYOUT: "表单布局",
  PAGEBUIDER_SETTINGS_LABEL_WIDTH: "标签宽度",
  PAGEBUIDER_SETTINGS_COLON: "冒号",
  PAGEBUIDER_SETTINGS_HORIZONTAL: "水平",
  PAGEBUIDER_SETTINGS_VERTICAL: "垂直",
  PAGEBUIDER_SETTINGS_INLINE: "内联",
  PAGEBUIDER_SETTINGS_LARGE: "大号",
  PAGEBUIDER_SETTINGS_FORM_TABS_DATEPICKER: "日期设置",
  PAGEBUIDER_SETTINGS_SHOW_TODAY: "显示今天",
  PAGEBUIDER_SETTINGS_DATE: "日期",
  PAGEBUIDER_SETTINGS_DATE_TIME: "日期时间",
  PAGEBUIDER_ELEMENT_TYPE_TIME: "时间",
  PAGEBUIDER_SETTINGS_MONTH: "month",
  PAGEBUIDER_SETTINGS_YEAR: "year",
  PAGEBUIDER_SETTINGS_FORMAT: "时间格式",
  PAGEBUIDER_SETTINGS_INPUT_THE_FORMAT: "请输入时间格式",
  PAGEBUIDER_SETTINGS_SHOW_NOW: "显示现在时间",
  PAGEBUIDER_SETTINGS_FORM_TABS_TIMERPICKER: "时间设置",
  PAGEBUIDER_SETTINGS_HOUR_STEP: "小时步长",
  PAGEBUIDER_SETTINGS_MINUTE_STEP: "分钟步长",
  PAGEBUIDER_SETTINGS_SECOND_STEP: "秒步长",
  PAGEBUIDER_SETTINGS_FORM_TABS_RANGEPICKER: "日期范围设置",
  PAGEBUIDER_SETTINGS_SEPARATOR: "分隔符",
  PAGEBUIDER_SETTINGS_ALLOW_START_EMPTY: "开始空的",
  PAGEBUIDER_SETTINGS_ALLOW_END_EMPTY: "结束空的",
  PAGEBUIDER_SETTINGS_START_DISABLE: "开始禁用",
  PAGEBUIDER_SETTINGS_END_DISABLE: "结束禁用",
  PAGEBUIDER_SETTINGS_DATE_INPUTREADONLY: "只读",
  PAGEBUIDER_SETTINGS_ATTRS: "属性",
  PAGEBUIDER_SETTINGS_COM_ATTR: "组件属性",
  PAGEBUIDER_SETTINGS_FORM_ATTR: "表单属性",
  PAGEBUIDER_SETTINGS: "基础设置",
  PAGEBUIDER_SETTINGS_COLUMNS_TITLE: "栅格设置",
  PAGEBUIDER_MENU_NULL: "空的",
  PAGEBUIDER_SETTINGS_PREVIEW: "预览",
  PAGEBUIDER_SETTINGS_INSERTABLE: "允许新增行",
  PAGEBUIDER_SETTINGS_REMOVEABLE: "允许删除行",
  PAGEBUIDER_SETTINGS_UPMOVEABLE: "允许上移行",
  PAGEBUIDER_SETTINGS_DOWNMOVEABLE: "允许下移行",
  PAGEBUIDER_SETTINGS_COLUMN_NAME: "列名称",
  PAGEBUIDER_SETTINGS_COLUMN_CODE: "列编码",
  PAGEBUIDER_SETTINGS_COLUMN_WIDTH: "列宽",
  PAGEBUIDER_SETTINGS_COLUMN_TYPE: "字段类型",
  PAGEBUIDER_SETTINGS_COLUMN_OPTION: "字段配置",
  PAGEBUIDER_SETTINGS_COLUMN_REQUIRE: "是否必填",
  PAGEBUIDER_CLEAR_PAGE_TIPS: "当前无模板需要删除。",
  PAGEBUIDER_CONFIRM_BTN_OK: "好的",
  PAGEBUIDER_SETTINGS_CANCEL: "取消",
  PAGEBUIDER_SETTINGS_CONFIRM: "确认",
  PAGEBUIDER_SAVEPAGE_TIPS_NO_FORM: "页面无表单。",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_KEY: "键",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_TITLE: "标题",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_COLUMN_WIDTH: "列宽",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_ELLIPSIS: "是否截断",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_ALIGN: "对齐",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_OPEN_RENDER: "开启渲染",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_ADVANCED: "高级设置",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_OTHER: "其他设置",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_TIPS:
    "生成该列render配置，该列单元格可编辑",
  PAGEBUIDER_SETTINGS_DOWNLOAD_CODE: "代码下载",
  PAGEBUIDER_SETTINGS_NAME_REPEAT_TIP: "控件名不可设置重复！",
  PAGEBUIDER_SETTINGS_NAME_NULL_TIP: "控件名必填！",
  PAGEBUIDER_TABLE_OPERATION: "操作",
  PAGEBUIDER_ELEMENT_COLLAPSE: "折叠面板",
  PAGEBUIDER_SETTINGS_NEW_PANEL: "新增面板",
  PAGEBUIDER_ELEMENT_PANEL: "卡片",
  PAGEBUIDER_SETTINGS_COLLAPSE_ARROW: "折叠箭头",
  PAGEBUIDER_SETTINGS_TEXT_ACTION: "文本设置",
  PAGEBUIDER_SETTINGS_FONTSIZE: "字体大小",
  PAGEBUIDER_SETTINGS_LINE_HEIGHT: "行高",
  PAGEBUIDER_ELEMENT_GROUP_BASIC: "基础组件",
  PAGEBUIDER_ELEMENT_Tabs: "页签",
  PAGEBUIDER_SETTINGS_TAB_POSITION: "页签位置",
  PAGEBUIDER_SETTINGS_TAB_TYPE: "页签样式",
  PAGEBUIDER_SETTINGS_TAB_DEFAULT_KEY: "默认选中",
  PAGEBUIDER_ELEMENT_CONTAINER: "容器",
  PAGEBUIDER_ELEMENT_FORM_CONTAINER: "表单容器",
  PAGEBUIDER_ELEMENT_PLACE_TOP_LEFT: "上左",
  PAGEBUIDER_ELEMENT_PLACE_TOP: "上",
  PAGEBUIDER_ELEMENT_PLACE_TOP_RIGHT: "上右",
  PAGEBUIDER_ELEMENT_PLACE_CENTER_LEFT: "左中",
  PAGEBUIDER_ELEMENT_PLACE_CENTER: "中",
  PAGEBUIDER_ELEMENT_PLACE_CENTER_RIGHT: "右中",
  PAGEBUIDER_ELEMENT_PLACE_BOTTOM_LEFT: "下左",
  PAGEBUIDER_ELEMENT_PLACE_BOTTOM_CENTER: "下中",
  PAGEBUIDER_ELEMENT_PLACE_BOTTOM_RIGHT: "下右",
  PAGEBUIDER_ELEMENT_FORM_HYPERLINK: "超链接",
  PAGEBUIDER_ELEMENT_FORM_HYPERLINK_ADDRESS: "超链接地址",
  PAGEBUIDER_FONT_SIZE: "字体大小",
  PAGEBUIDER_SETTINGS_DATE_STATUS: "状态",
  PAGEBUIDER_ELEMENT_FORM_CUSTOM_MODAL: "自定义弹窗",
  PAGEBUIDER_ELEMENT_TRANSFER: "穿梭框",
  PAGEBUIDER_ELEMENT_PROPERTY_AUTOINITIALIZE: "自动初始化",
  PAGEBUIDER_ELEMENT_PROPERTY_SEARCH: "搜索",
  PAGEBUIDER_ELEMENT_PROPERTY_SELECT_ALL: "全选",
  PAGEBUIDER_SETTINGS_MPDAL_TITLE: "标题",
  PAGEBUIDER_SETTINGS_TRANSFER_LABEL: "显示字段",
  PAGEBUIDER_SETTINGS_TRANSFER_KEY: "主键",
  PAGEBUIDER_ELEMENT_STEP: "步骤条",
  PAGEBUIDER_SETTINGS_STEP_TITLE: "标题",
  PAGEBUIDER_SETTINGS_STEP_DESC: "描述",
  PAGEBUIDER_SETTINGS_STEP_STATE: "状态",
  PAGEBUIDER_SETTINGS_STEP_POSITION: "步骤设置",
  PAGEBUIDER_ELEMENT_FILTER_ITEM: "筛选项",
  ORDER_FIRST: "操作列置首",
};

locales[languages[1]] = {
  ORDER_FIRST: "order first",
  PAGEBUIDER_ELEMENT_SORT_FORM: "Form",
  PAGEBUIDER_ELEMENT_FORM_INPUT: "Input",
  PAGEBUIDER_ELEMENT_FORM_INPUTNUMBER: "InputNumber",
  PAGEBUIDER_ELEMENT_FORM_TEXTAREA: "TextArea",
  PAGEBUIDER_ELEMENT_FORM_PASSWORD: "Password",
  PAGEBUIDER_ELEMENT_FORM_SELECT: "Select",
  PAGEBUIDER_ELEMENT_FORM_CASCADER: "Cascade",
  PAGEBUIDER_ELEMENT_FORM_RADIOGROUP: "Radio",
  PAGEBUIDER_ELEMENT_FORM_CHECKBOXGROUP: "Checkbox",
  PAGEBUIDER_ELEMENT_FORM_DATEPICKER: "DatePicker",
  PAGEBUIDER_ELEMENT_FORM_RANGEPICKER: "RangePicker",
  PAGEBUIDER_ELEMENT_FORM_TIMEPICKER: "TimePicker",
  PAGEBUIDER_ELEMENT_FORM_SWITCH: "Switch",
  PAGEBUIDER_ELEMENT_FORM_SLIDER: "Slider",
  PAGEBUIDER_ELEMENT_FORM_RATE: "Rate",
  PAGEBUIDER_ELEMENT_FORM_UPLOAD: "Upload",
  PAGEBUIDER_ELEMENT_FORM_POPEDIT: "PopEdit",
  PAGEBUIDER_ELEMENT_FORM_PARTICIPANT: "Participant",
  PAGEBUIDER_ELEMENT_TABLE_PARTICIPANT_ID: "Participant ID",
  PAGEBUIDER_ELEMENT_TABLE_PARTICIPANT_NAME: "Participant Name",
  PAGEBUIDER_ELEMENT_TABLE_PARTICIPANT_TYPE: "Participant Type",
  PARTICIPANT_SETTINGS_PAGE_URL: "Link",
  PAGEBUIDER_ELEMENT_FORM_IMAGEUPLOAD: "ImageUpload",
  PAGEBUIDER_ELEMENT_FORM_TREE: "Tree",
  PAGEBUIDER_ELEMENT_FORM_TREESELECT: "TreeSelect",
  PAGEBUIDER_SETTINGS_PROPERTY_REMOTE_COMPONENT: "remote component",
  PAGEBUIDER_SETTINGS_REMOTE_URL: "url",
  REMOTE_COMPONENT_PARAMTERS: "remote component parameters",
  PAGEBUIDER_ELEMENT_FORM_RICHEDITOR: "RichEditor",
  PAGEBUIDER_ELEMENT_FORM_BUTTON: "Button",
  PAGEBUIDER_ELEMENT_FORM_TABLE: "Table",
  PAGEBUIDER_ELEMENT_FORM_HEADERCELL: "HeaderCell",
  PAGEBUIDER_ELEMENT_FORM_TABLEEDIT: "TableEdit",
  PAGEBUIDER_EDITOR_TABLE_HEADER_CELL: "New Column",
  PAGEBUIDER_MSG_SETTINGS_SUCCESS: "Set options successful.",
  PAGEBUIDER_MSG_OPTIONS_REMOTE_SUCCESS: "Set remote options successful.",
  PAGEBUIDER_MSG_OPTIONS_REMOTE_FAIL:
    "Set remote options failed. Please check your data source.",
  PAGEBUIDER_MSG_OPTIONS_REMOTE_WARN:
    "Set remote options successful! But data not initialize yet",
  PAGEBUIDER_MSG_OPTIONS_STATIC_SUCCESS: "Set static options successful.",
  PAGEBUIDER_MSG_SETTINGS_FAIL:
    "Set options failed. Please check your data source.",
  PAGEBUIDER_MSG_UPLOAD_FAIL:
    "Error while uploading file. Cause: 'File type does not match file extension'.",
  PAGEBUIDER_MSG_DATA_SUCCESS: "Set data source successful.",
  PAGEBUIDER_MSG_DATA_FAIL: "Set data source failed! Please check your url.",
  PAGEBUIDER_TITLE_STATIC: "Edit static data",
  PAGEBUIDER_TITLE_REMOTE: "Edit remote data",
  PAGEBUIDER_ELEMENT_TEXT_SUBMIT: "Submit",
  PAGEBUIDER_PLS_SELECT: "Please Select",
  PAGEBUIDER_PLS_SELECT_ICON: "Please Select Icon",
  PAGEBUIDER_ICON_TYPE_NORMAL: "Normal",
  PAGEBUIDER_ICON_TYPE_OUTLINED: "Outlined",
  PAGEBUIDER_ICON_TYPE_FILLED: "Filled",
  PAGEBUIDER_ICON_TYPE_TWO_TONE: "TwoTone",
  PAGEBUIDER_ICON_SORT_DIRECTION_ICON: "Direction Icons",
  PAGEBUIDER_ICON_SORT_TIPS_ICON: "Tips Icons",
  PAGEBUIDER_ICON_SORT_EDIT_ICON: "Edit Icons",
  PAGEBUIDER_ICON_SORT_NORMAL_ICON: "Normal Icons",
  PAGEBUIDER_LANGUAGE_ZH: "Chinese",
  PAGEBUIDER_LANGUAGE_EN: "English",
  PAGEBUIDER_ELEMENT_GROUP_CONTAINER: "Container Elements",
  PAGEBUIDER_ELEMENT_GROUP_LAYOUT: "Layout Elements",
  PAGEBUIDER_ELEMENT_GROUP_FORM_INPUT: "Input Elements",
  PAGEBUIDER_ELEMENT_GROUP_FORM_SELECT: "Select Elements",
  PAGEBUIDER_ELEMENT_GROUP_FORM_COMPLEX: "Complex Elements",
  PAGEBUIDER_ELEMENT_GROUP_FORM_CUSTOM: "Custom Elements",
  PAGEBUIDER_OPERATE_DELETE_TIPS: "Tips",
  PAGEBUIDER_OPERATE_DELETE_TIPS_CONTENT:
    "Are you sure to delete all components？",
  PAGEBUIDER_SETTINGS_INPUT_TABS_INPUT: "Input Settings",
  PAGEBUIDER_SETTINGS_INPUT_TABS_MACRO: "Macro Settings",
  PAGEBUIDER_SETTINGS_INPUT_TABS_LABEL: "Lable Settings",
  PAGEBUIDER_SETTINGS_INPUT_TABS_INPUTNUMBER: "InputNumber Settings",
  PAGEBUIDER_SETTINGS_NAME: "Name",
  PAGEBUIDER_SETTINGS_ALLOW_CLEAR: "Allow Clear",
  PAGEBUIDER_SETTINGS_DEFAULT_VALUE: "Default Value",
  PAGEBUIDER_SETTINGS_PLACE_HOLDER: "Place Holder",
  PAGEBUIDER_SETTINGS_VISIBLE: "Visible",
  PAGEBUIDER_SETTINGS_VISIBLE_DOM: "Dom Exists",
  PAGEBUIDER_SETTINGS_DISABLED: "Disabled",
  PAGEBUIDER_SETTINGS_REQUIRED: "Verification",
  PAGEBUIDER_SETTINGS_REQUIRED_ITEM: "Required",
  PAGEBUIDER_SETTINGS_TYPE: "Type",
  PAGEBUIDER_SETTINGS_ADDON_BEFORE: "Addon Before",
  PAGEBUIDER_SETTINGS_ADDON_AFTER: "Addon After",
  PAGEBUIDER_SETTINGS_MAX_LENGTH: "MaxLength",
  PAGEBUIDER_SETTINGS_MESSAGE: "Message",
  PAGEBUIDER_SETTINGS_TEXT: "Text",
  PAGEBUIDER_SETTINGS_URL: "Url",
  PAGEBUIDER_SETTINGS_PASSWORD: "Password",
  PAGEBUIDER_SETTINGS_TEL: "Tel",
  PAGEBUIDER_SETTINGS_EMAIL: "Email",
  PAGEBUIDER_SETTINGS_PLACEHOLDER_DEFAULT_VALUE: "Input the default value",
  PAGEBUIDER_SETTINGS_PLACEHOLDER_PLACEHOLDER: "Input the place holder",
  PAGEBUIDER_SETTINGS_MACRO: "Macro",
  PAGEBUIDER_SETTINGS_LABEL_SETTING: "Label Setting",
  PAGEBUIDER_SETTINGS_LABEL_TEXT: "Label Text",
  PAGEBUIDER_SETTINGS_LABEL_ALIGN: "Label Align",
  PAGEBUIDER_SETTINGS_COLOR: "Color",
  PAGEBUIDER_SETTINGS_LABEL_OFFSET: "Label Offset",
  PAGEBUIDER_SETTINGS_LEFT: "Left",
  PAGEBUIDER_SETTINGS_CENTER: "Center",
  PAGEBUIDER_SETTINGS_RIGHT: "Right",
  PAGEBUIDER_SETTINGS_LABEL: "Label",
  PAGEBUIDER_SETTINGS_OFFSET: "Offset",
  PAGEBUIDER_SETTINGS_CASCADE_SETTING: "Cascade Setting",
  PAGEBUIDER_SETTINGS_DATASOURCE_RELATION: "Data Source Relation",
  PAGEBUIDER_SETTINGS_VISIBLE_RELATION: "Visible Relation",
  PAGEBUIDER_SETTINGS_DISABLE_RELATION: "Disable Relation",
  PAGEBUIDER_SETTINGS_REQUIRE_RELATION: "Require Relation",
  PAGEBUIDER_SETTINGS_RELATION: "Relation",
  PAGEBUIDER_SETTINGS_INPUT: "Input",
  PAGEBUIDER_SETTINGS_OUTPUT: "Output",
  PAGEBUIDER_SETTINGS_DEFAULT_OUTPUT: "DefaultOutput",
  PAGEBUIDER_SETTINGS_PLEASE_INPUT_VALUE: "Please Input Value",
  PAGEBUIDER_SETTINGS_RELATION_ITEM: "Relation Item",
  PAGEBUIDER_SETTINGS_VALUE: "Value",
  PAGEBUIDER_SETTINGS_EVENT_SETTING: "Event",
  PAGEBUIDER_SETTINGS_PLS_INPUT: "Please Input",
  PAGEBUIDER_SETTINGS_EVENT: "Event",
  PAGEBUIDER_SETTINGS_FUNCTION: "Function",
  PAGEBUIDER_SETTINGS_OPERATION: "opt",
  PAGEBUIDER_SETTINGS_CONFIRM_DELETE: "Sure to delete?",
  PAGEBUIDER_SETTINGS_CONFIRM_CANCEL: "Sure to cancel?",
  PAGEBUIDER_SETTINGS_ADD_NEW_EVENT: "Add new event",
  PAGEBUIDER_SETTINGS_COLUMN_GRID: "Column-Grid",
  PAGEBUIDER_SETTINGS_INPUTNUMBER: "InputNumber",
  PAGEBUIDER_SETTINGS_MAX: "Max",
  PAGEBUIDER_SETTINGS_MIN: "Min",
  PAGEBUIDER_SETTINGS_PRECISION: "Precision",
  PAGEBUIDER_SETTINGS_STEP: "Step",
  PAGEBUIDER_SETTINGS_WIDTH: "Width",
  PAGEBUIDER_SETTINGS_FORM_TABS_TEXTAREA: "TextArea Settings",
  PAGEBUIDER_SETTINGS_AUTOSIZE: "Autosize",
  PAGEBUIDER_SETTINGS_MAX_ROWS: "MaxRows",
  PAGEBUIDER_SETTINGS_TEXT_AREA: "TextArea",
  PAGEBUIDER_SETTINGS_FORM_TABS_PASSWORD: "Password Settings",
  PAGEBUIDER_SETTINGS_VISIBILITY_TOGGLE: "VisibilityToggle",
  PAGEBUIDER_SETTINGS_READONLY: "ReadOnly",
  PAGEBUIDER_SETTINGS_HEIGHT: "Height",
  PAGEBUIDER_SETTINGS_FULL_HEIGHT: "Full Height",
  PAGEBUIDER_SETTINGS_MARGIN: "Margin",
  PAGEBUIDER_SETTINGS_LAYOUT: "Layout",
  PAGEBUIDER_SETTINGS_DESKTOP: "Desktop",
  PAGEBUIDER_SETTINGS_MOBILE: "Mobile",
  PAGEBUIDER_SETTINGS_SHOW_ADVANCED: "Show advanced options",
  PAGEBUIDER_SETTINGS_PADDING: "Padding",
  PAGEBUIDER_SETTINGS_FORM_TABS_BUTTON: "Button Settings",
  PAGEBUIDER_SETTINGS_FORM_TABS_COLUMN: "Column Settings",
  PAGEBUIDER_SETTINGS_BUTTON_ALIGN: "Button Align",
  PAGEBUIDER_SETTINGS_FORM: "Form",
  PAGEBUIDER_SETTINGS_GHOST: "Ghost",
  PAGEBUIDER_SETTINGS_HTML_TYPE: "Html Type",
  PAGEBUIDER_SETTINGS_ICON: "Icon",
  PAGEBUIDER_SETTINGS_BTN_TYPE_HTML_SUBMIT: "submit",
  PAGEBUIDER_SETTINGS_BTN_TYPE_HTML_RESET: "reset",
  PAGEBUIDER_SETTINGS_BTN_TYPE_HTML_BUTTON: "button",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_PRIMARY: "Primary",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_DASHED: "Dashed",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_DANGER: "Danger",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_LINK: "Link",
  PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_DEFAULT: "Default",
  PAGEBUIDER_SETTINGS_FORM_TABS_SELECT: "Select Settings",
  PAGEBUIDER_SETTINGS_FORM_TABS_OPTIONS: "Data Source Settings",
  PAGEBUIDER_SETTINGS_SHOW_SEARCH: "Show Search",
  PAGEBUIDER_SETTINGS_FILTER_PROP: "Filter Prop",
  PAGEBUIDER_SETTINGS_SHOW_ARROW: "Show Arrow",
  PAGEBUIDER_SETTINGS_LISTHEIGHT: "List Max Height",
  PAGEBUIDER_SETTINGS_MODE: "Mode",
  PAGEBUIDER_SETTINGS_MAX_TAG_COUNT: "Max Tag Count",
  PAGEBUIDER_SETTINGS_MODE_SINGLE: "Single",
  PAGEBUIDER_SETTINGS_MODE_MULTIPLE: "Multiple",
  PAGEBUIDER_SETTINGS_MODE_TAGS: "Tags",
  PAGEBUIDER_SETTINGS_DATASOURCE: "DataSource",
  PAGEBUIDER_SETTINGS_DATASOURCE_STATIC: "Static",
  PAGEBUIDER_SETTINGS_DATASOURCE_REMOTE: "Remote",
  PAGEBUIDER_SETTINGS_ADD_NEW_OPTION: "Add new option",
  PAGEBUIDER_SETTINGS_FORM_TABS_CASCADER: "Cascade Settings",
  "PAGEBUIDER_SETTINGS_FORM-TABS_SELECT_OPTIONS": "Data Source Options",
  PAGEBUIDER_SETTINGS_CHANGE_ON_SELECT: "ChangeOnSelect",
  PAGEBUIDER_SETTINGS_EXPAND_TRIGGER: "Expand Trigger",
  PAGEBUIDER_SETTINGS_POPUP_PLACEMENT: "Popup Placement",
  PAGEBUIDER_SETTINGS_TRIGGER_CLICK: "click",
  PAGEBUIDER_SETTINGS_TRIGGER_HOVER: "hover",
  PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOMLEFT: "bottomLeft",
  PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOMRIGHT: "bottomRight",
  PAGEBUIDER_SETTINGS_PLACEMENT_TOPLEFT: "topLeft",
  PAGEBUIDER_SETTINGS_PLACEMENT_TOPRIGHT: "topRight",
  PAGEBUIDER_SETTINGS_FORM_TABS_RADIO: "Radio Settings",
  PAGEBUIDER_SETTINGS_FORM_TABS_CHECKBOX: "Checkout Settins",
  PAGEBUIDER_SETTINGS_FORM_TABS_SWITCH: "Switch Settings",
  PAGEBUIDER_SETTINGS_SWITCH_DEFAULT_CHECKED: "Default Checked",
  PAGEBUIDER_SETTINGS_SWITCH_CHECKED_CHILD: "Checked Children",
  PAGEBUIDER_SETTINGS_SWITCH_UNCHECKED_CHILD: "Unchecked Children",
  PAGEBUIDER_SETTINGS_FORM_TABS_RATE: "Rate Settings",
  PAGEBUIDER_SETTINGS_ALLOW_HALF: "Allow Half",
  PAGEBUIDER_SETTINGS_COUNT: "Count",
  PAGEBUIDER_SETTINGS_FORM_TABS_SLIDER: "Slider Settings",
  PAGEBUIDER_SETTINGS_DOTS: "Dots",
  PAGEBUIDER_SETTINGS_RANGE: "Range",
  PAGEBUIDER_SETTINGS_REVERSE: "Reverse",
  PAGEBUIDER_SETTINGS_TOOLTIP: "Tooltip",
  PAGEBUIDER_SETTINGS_PLACEMENT: "Placement",
  PAGEBUIDER_SETTINGS_PLACEMENT_TOP: "top",
  PAGEBUIDER_SETTINGS_PLACEMENT_RIGHT: "right",
  PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOM: "bottom",
  PAGEBUIDER_SETTINGS_PLACEMENT_LEFT: "left",
  PAGEBUIDER_SETTINGS_PLACEMENT_LEFTTOP: "leftTop",
  PAGEBUIDER_SETTINGS_PLACEMENT_LEFTBOTTOM: "leftBottom",
  PAGEBUIDER_SETTINGS_PLACEMENT_RIGHTTOP: "rightTop",
  PAGEBUIDER_SETTINGS_PLACEMENT_RIGHTBOTTOM: "rightBottom",
  PAGEBUIDER_SETTINGS_UNSET: "none",
  PAGEBUIDER_SETTINGS_CHINESE: "chinese",
  PAGEBUIDER_SETTINGS_ADD_ITEM: "Add Item",
  PAGEBUIDER_SETTINGS_REQUIRED_TIPS: "This field is required.",
  PAGEBUIDER_SETTINGS_REQUIRED_TABLE_TIPS: "Table data source cannot be empty.",
  PAGEBUIDER_SETTINGS_TIPS_ACCEPT_TYPE: "Please input the accept type.",
  PAGEBUIDER_SETTINGS_TIPS_REQUIRE_SELECT: "Please select rules",
  PAGEBUIDER_SETTINGS_TIPS_REQUIRE_INPUT: "Please input regular expressions",
  PAGEBUIDER_SETTINGS_PLATFORM_RELATED_DEVELOPMENT:
    "Platform Related Development",
  PAGEBUIDER_SETTINGS_FORM_TABS_BASIC: "Basic Settings",
  PAGEBUIDER_SETTINGS_FORM_TABS_DATA: "Data Source Settings",
  PAGEBUIDER_SETTINGS_DEFAULT_VALUE_SET: "Default Value Settings",
  PAGEBUIDER_SETTINGS_DATATEXTFIELD: "DataTextField",
  PAGEBUIDER_SETTINGS_DATAVALUEFIELD: "DataValueField",
  PAGEBUIDER_SETTINGS_PAGE_URL: "PAGE URL",
  PAGEBUIDER_SETTINGS_TITLE: "Title",
  PAGEBUIDER_SETTINGS_MODAL_WIDTH: "Modal Width",
  PAGEBUIDER_SETTINGS_MODAL_HEIGHT: "Modal Height",
  PAGEBUIDER_SETTINGS_ADD_NEW_ITEM: "Add new item",
  PAGEBUIDER_SETTINGS_PLEASE_INPUT_NAME: "Please Input Name",
  PAGEBUIDER_SETTINGS_AUTO_INITILIZE: "Tree Default Expand All",
  PAGEBUIDER_SETTINGS_EXPANDALL: "show all",
  PAGEBUIDER_SETTINGS_MULTIPLE: "Multiple",
  PAGEBUIDER_SETTINGS_HIDE_LABEL: "Hide Label",
  PAGEBUIDER_SETTINGS_SHOWERROR: "show error file",
  PAGEBUIDER_SETTINGS_TABLE_KEY: "Table Key",
  PAGEBUIDER_SETTINGS_SIZE: "Size",
  PAGEBUIDER_SETTINGS_SCROLLX: "ScrollX",
  PAGEBUIDER_SETTINGS_SCROLLY: "ScrollY",
  PAGEBUIDER_SETTINGS_BORDERED: "Bordered",
  PAGEBUIDER_SETTINGS_EXPANDICONPOSITION: "ExpandIconPosition",
  PAGEBUIDER_SETTINGS_TABLE_LAYOUT: "Table Layout",
  PAGEBUIDER_SETTINGS_ROW_SELECT: "Row Select",
  PAGEBUIDER_SETTINGS_PAGINATION: "Pagination",
  PAGEBUIDER_SETTINGS_PAGE_SIZE: "Page Size",
  PAGEBUIDER_SETTINGS_SIZE_CHANGER: "Size Changer",
  PAGEBUIDER_SETTINGS_PAGE_TOTAL: "Total",
  PAGEBUIDER_SETTINGS_CHECKBOX: "Checkbox",
  PAGEBUIDER_SETTINGS_RADIO: "Radio",
  PAGEBUIDER_SETTINGS_FIXED: "Fixed",
  PAGEBUIDER_SETTINGS_DEFAULT: "Default",
  PAGEBUIDER_SETTINGS_MIDDLE: "Middle",
  PAGEBUIDER_SETTINGS_SMALL: "Small",
  PAGEBUIDER_SETTINGS_COLUMNS: "Columns",
  PAGEBUIDER_SETTINGS_EDIT_COLUMNS_DATA: "Edit Columns Data",
  PAGEBUIDER_SETTINGS_EDIT_DATASOURCE: "Edit DataSource",
  PAGEBUIDER_SETTINGS_FORM_TABS_UPLOAD: "Upload Settings",
  PAGEBUIDER_SETTINGS_ACCEPT: "Accept",
  PAGEBUIDER_SETTINGS_UPLOAD_URL: "Upload Url",
  PAGEBUIDER_SETTINGS_QUERY_URL: "Query Url",
  PAGEBUIDER_SETTINGS_DOWNLOAD_URL: "Download Url",
  PAGEBUIDER_SETTINGS_PREVIEW_URL: "Preview Url",
  PAGEBUIDER_SETTINGS_WITH_CREDENTIALS: "WithCredentials",
  PAGEBUIDER_SETTINGS_DIRECTORY: "Directory",
  PAGEBUIDER_SETTINGS_PLS_SELECT_FILE_TYPE: "Please select file type",
  PAGEBUIDER_SETTINGS_PLS_INPUT_ACCEPT_TYPE: "Please input the accept type",
  PAGEBUIDER_SETTINGS_CLICK_TO_UPLOAD: "Click to upload",
  PAGEBUIDER_SETTINGS_FORM_TABS_URL: "URL SETTINGS",
  PAGEBUIDER_SETTINGS_UPLOAD_NAME: "Upload Name",
  PAGEBUIDER_SETTINGS_UPLOAD_FILESIZE: "Size",
  PAGEBUIDER_SETTINGS_PREVIEW_WIDTH: "Preview Width",
  PAGEBUIDER_SETTINGS_PREVIEW_HEIGHT: "Preview Height",
  PAGEBUIDER_SETTINGS_BUTTON_TEXT: "Button Text",
  PAGEBUIDER_SETTINGS_UPLOAD_SUCCESS: "Success massage",
  PAGEBUIDER_SETTINGS_UPLOAD_ERROR: "Error message",
  PAGEBUIDER_SETTINGS_UPLOAD_FAILD: "Failed message",
  PAGEBUIDER_SETTINGS_UPLOAD_SUCCESS_DEFAULT: "file uploaded successfully",
  PAGEBUIDER_SETTINGS_UPLOAD_ERROR_DEFAULT:
    "File type does not match file extension",
  PAGEBUIDER_SETTINGS_UPLOAD_FAILD_DEFAULT: "file upload failed",
  PAGEBUIDER_SETTINGS_UPLOAD_ERROR_SIZE:
    "File size does not match file extension: ",
  PAGEBUIDER_SETTINGS_UPLOAD_ID_NAME: "ID field Name",
  PAGEBUIDER_SETTINGS_VERTICAL_ALIGN: "Vertical align",
  PAGEBUIDER_SETTINGS_HORIZONTAL_ALIGN: "Horizontal align",
  PAGEBUIDER_SETTINGS_SHADOW: "Shadow",
  PAGEBUIDER_SETTINGS_HORIZONTAL_OFFSET: "Horizontal offset",
  PAGEBUIDER_SETTINGS_VERTICAL_OFFSET: "Vertical offset",
  PAGEBUIDER_SETTINGS_BLUR: "Blur",
  PAGEBUIDER_SETTINGS_SPREAD: "Spread",
  PAGEBUIDER_SETTINGS_RADIUS: "Radius",
  PAGEBUIDER_SETTINGS_STYLE: "Style",
  PAGEBUIDER_SETTINGS_BORDERS: "Borders",
  PAGEBUIDER_SETTINGS_BORDER: "Border",
  PAGEBUIDER_SETTINGS_STYLE_NONE: "None",
  PAGEBUIDER_SETTINGS_STYLE_SOLID: "Solid",
  PAGEBUIDER_SETTINGS_STYLE_DASHED: "Dashed",
  PAGEBUIDER_SETTINGS_STYLE_DOTTED: "Dotted",
  PAGEBUIDER_SETTINGS_ANIMATION: "Animation",
  PAGEBUIDER_SETTINGS_BACKGROUND: "Background",
  PAGEBUIDER_SETTINGS_IMAGE: "Image",
  PAGEBUIDER_SETTINGS_SELECT_AN_IAMGE: "Select an image",
  PAGEBUIDER_SETTINGS_SCALING: "Scaling",
  PAGEBUIDER_SETTINGS_POSITION: "Position",
  PAGEBUIDER_SETTINGS_COVER: "Cover",
  PAGEBUIDER_SETTINGS_CONTAIN: "Contain",
  PAGEBUIDER_SETTINGS_ORIGIN_SIZE: "Origin Size",
  PAGEBUIDER_SETTINGS_TITLE_HORIZONTAL: "Title Horizontally",
  PAGEBUIDER_SETTINGS_TITLE_VERTICAL: "Title Vertically",
  PAGEBUIDER_SETTINGS_FORM_SETTING: "Form Setting",
  PAGEBUIDER_SETTINGS_FORM_SETTINGS: "Form Settings",
  PAGEBUIDER_SETTINGS_FORM_SIZE: "Form Size",
  PAGEBUIDER_SETTINGS_FORM_LAYOUT: "Form Layout",
  PAGEBUIDER_SETTINGS_LABEL_WIDTH: "LabelWidth",
  PAGEBUIDER_SETTINGS_COLON: "COLON",
  PAGEBUIDER_SETTINGS_HORIZONTAL: "Horizontal",
  PAGEBUIDER_SETTINGS_VERTICAL: "Vertical",
  PAGEBUIDER_SETTINGS_INLINE: "Inline",
  PAGEBUIDER_SETTINGS_LARGE: "Large",
  PAGEBUIDER_SETTINGS_FORM_TABS_DATEPICKER: "DatePicker Settings",
  PAGEBUIDER_SETTINGS_SHOW_TODAY: "Show Today",
  PAGEBUIDER_SETTINGS_DATE: "date",
  PAGEBUIDER_SETTINGS_DATE_TIME: "date_time",
  PAGEBUIDER_ELEMENT_TYPE_TIME: "Time",
  PAGEBUIDER_SETTINGS_MONTH: "month",
  PAGEBUIDER_SETTINGS_YEAR: "year",
  PAGEBUIDER_SETTINGS_FORMAT: "Format",
  PAGEBUIDER_SETTINGS_INPUT_THE_FORMAT: "Input the format",
  PAGEBUIDER_SETTINGS_SHOW_NOW: "Show Now",
  PAGEBUIDER_SETTINGS_FORM_TABS_TIMERPICKER: "TimerPicker Settings",
  PAGEBUIDER_SETTINGS_HOUR_STEP: "Hour Step",
  PAGEBUIDER_SETTINGS_MINUTE_STEP: "Minute Step",
  PAGEBUIDER_SETTINGS_SECOND_STEP: "Second Step",
  PAGEBUIDER_SETTINGS_FORM_TABS_RANGEPICKER: "RangePicker Settings",
  PAGEBUIDER_SETTINGS_SEPARATOR: "Separator",
  PAGEBUIDER_SETTINGS_ALLOW_START_EMPTY: "Allow Start Empty",
  PAGEBUIDER_SETTINGS_ALLOW_END_EMPTY: "Allow End Empty",
  PAGEBUIDER_SETTINGS_START_DISABLE: "Start Disable",
  PAGEBUIDER_SETTINGS_END_DISABLE: "End Disable",
  PAGEBUIDER_SETTINGS_DATE_INPUTREADONLY: "inputReadOnly",
  PAGEBUIDER_SETTINGS_ATTRS: "Attr",
  PAGEBUIDER_SETTINGS_COM_ATTR: "FormItem Attr",
  PAGEBUIDER_SETTINGS_FORM_ATTR: "Form Attr",
  PAGEBUIDER_SETTINGS: "Base Settings",
  PAGEBUIDER_SETTINGS_COLUMNS_TITLE: "Columns Setting",
  PAGEBUIDER_MENU_NULL: "Null",
  PAGEBUIDER_SETTINGS_PREVIEW: "Preview",
  PAGEBUIDER_SETTINGS_INSERTABLE: "Allow add row",
  PAGEBUIDER_SETTINGS_REMOVEABLE: "Allow delete row",
  PAGEBUIDER_SETTINGS_UPMOVEABLE: "Allow up move row",
  PAGEBUIDER_SETTINGS_DOWNMOVEABLE: "Allow down move row",
  PAGEBUIDER_SETTINGS_COLUMN_NAME: "Column Name",
  PAGEBUIDER_SETTINGS_COLUMN_CODE: "Column Code",
  PAGEBUIDER_SETTINGS_COLUMN_WIDTH: "Column Width",
  PAGEBUIDER_SETTINGS_COLUMN_TYPE: "Column Type",
  PAGEBUIDER_SETTINGS_COLUMN_OPTION: "Column Option",
  PAGEBUIDER_SETTINGS_COLUMN_REQUIRE: "Column require",
  PAGEBUIDER_CLEAR_PAGE_TIPS: "There are currently no templates to delete。",
  PAGEBUIDER_CONFIRM_BTN_OK: "OK",
  PAGEBUIDER_SETTINGS_CANCEL: "Cancel",
  PAGEBUIDER_SETTINGS_CONFIRM: "Confirm",
  PAGEBUIDER_SAVEPAGE_TIPS_NO_FORM: "No form in the page.",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_KEY: "Key",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_TITLE: "Title",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_COLUMN_WIDTH: "Column width",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_ELLIPSIS: "Ellipsis",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_ALIGN: "Align",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_OPEN_RENDER: "Open Render",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_ADVANCED: "Advanced Settings",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_OTHER: "Other Settings",
  PAGEBUIDER_SETTINGS_TABLE_HEADER_CELL_TIPS:
    "Generate the column render configuration, and the column cell can be edited.",
  PAGEBUIDER_SETTINGS_DOWNLOAD_CODE: "Code Download",
  PAGEBUIDER_SETTINGS_NAME_REPEAT_TIP:
    "The control name cannot be set to repeat!",
  PAGEBUIDER_SETTINGS_NAME_NULL_TIP: "Control name is required!",
  PAGEBUIDER_TABLE_OPERATION: "Operation",
  PAGEBUIDER_ELEMENT_COLLAPSE: "Collapse",
  PAGEBUIDER_SETTINGS_NEW_PANEL: "New Panel",
  PAGEBUIDER_ELEMENT_PANEL: "Card",
  PAGEBUIDER_SETTINGS_COLLAPSE_ARROW: "Arrow",
  PAGEBUIDER_SETTINGS_TEXT_ACTION: "Text Settings",
  PAGEBUIDER_SETTINGS_FONTSIZE: "Font Size",
  PAGEBUIDER_SETTINGS_LINE_HEIGHT: "Line Height",
  PAGEBUIDER_ELEMENT_GROUP_BASIC: "Basic Elements",
  PAGEBUIDER_ELEMENT_Tabs: "Tabs",
  PAGEBUIDER_SETTINGS_TAB_POSITION: "Tab Position",
  PAGEBUIDER_SETTINGS_TAB_TYPE: "Tab Type",
  PAGEBUIDER_SETTINGS_TAB_DEFAULT_KEY: "Default Active Key",
  PAGEBUIDER_ELEMENT_CONTAINER: "Container",
  PAGEBUIDER_ELEMENT_FORM_CONTAINER: "Form Container",
  PAGEBUIDER_ELEMENT_PLACE_TOP_LEFT: "TopLeft",
  PAGEBUIDER_ELEMENT_PLACE_TOP: "Top",
  PAGEBUIDER_ELEMENT_PLACE_TOP_RIGHT: "TopRight",
  PAGEBUIDER_ELEMENT_PLACE_CENTER_LEFT: "CenterLeft",
  PAGEBUIDER_ELEMENT_PLACE_CENTER: "Center",
  PAGEBUIDER_ELEMENT_PLACE_CENTER_RIGHT: "CenterRight",
  PAGEBUIDER_ELEMENT_PLACE_BOTTOM_LEFT: "BottomLeft",
  PAGEBUIDER_ELEMENT_PLACE_BOTTOM_CENTER: "BottomCenter",
  PAGEBUIDER_ELEMENT_PLACE_BOTTOM_RIGHT: "BottomRight",
  PAGEBUIDER_ELEMENT_FORM_HYPERLINK: "Hyperlink",
  PAGEBUIDER_ELEMENT_FORM_HYPERLINK_ADDRESS: "Hyperlink Address",
  PAGEBUIDER_FONT_SIZE: "Font Size",
  PAGEBUIDER_SETTINGS_DATE_STATUS: "Mode",
  PAGEBUIDER_ELEMENT_FORM_CUSTOM_MODAL: "Custom Modal",
  PAGEBUIDER_ELEMENT_TRANSFER: "Transfer",
  PAGEBUIDER_ELEMENT_PROPERTY_AUTOINITIALIZE: "AutoInitialize",
  PAGEBUIDER_ELEMENT_PROPERTY_SEARCH: "Search",
  PAGEBUIDER_ELEMENT_PROPERTY_SELECT_ALL: "selectAll",
  PAGEBUIDER_SETTINGS_MPDAL_TITLE: "Title",
  PAGEBUIDER_SETTINGS_TRANSFER_LABEL: "Label",
  PAGEBUIDER_SETTINGS_TRANSFER_KEY: "Key",
  PAGEBUIDER_ELEMENT_STEP: "Steps",
  PAGEBUIDER_SETTINGS_STEP_TITLE: "Title",
  PAGEBUIDER_SETTINGS_STEP_DESC: "Direction",
  PAGEBUIDER_SETTINGS_STEP_STATE: "Status",
  PAGEBUIDER_SETTINGS_STEP_POSITION: "Step Setting",
  PAGEBUIDER_ELEMENT_FILTER_ITEM: "filter item",
};
export default locales;
